import { FunctionComponent } from 'react';
import { Div, Headline, Logo } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import Login from './Login/Login';
import LoginNewUser from './LoginNewUser/LoginNewUser';
import classes from './Authentication.module.css';
import LoginFailed from './LoginFailed/LoginFailed';
import LoginNoAccess from './LoginNoAccess/LoginNoAccess';
import LoggedOut from './LoggedOut/LoggedOut';
import Authenticated from './Authenticated/Authenticated';
import NoAccessToResource from './NoAccessToResource/NoAccessToResource';
import CompanyDevicePolicy from './CompanyDevicePolicy/CompanyDevicePolicy';
import MaintenanceMode from './MaintenanceMode/MaintenanceMode';

const Authentication: FunctionComponent = () => {
  const { t } = useTranslation('authentication');

  const { path } = useRouteMatch();

  return (
    <Div className={classes['authentication-main']}>
      <Div className={classes.background}></Div>
      <Div padding={{ top: 'xlg', bottom: 'lg' }} className={classes['title-row']}>
        <Logo size="xlg" color="white" />
        <Div margin={{ horizontal: 'md' }} className={classes.separator}></Div>
        <Headline size="sm" color="white">
          {t('LoginMain.title')}
        </Headline>
      </Div>
      <Div backgroundColor="white" className={classes.content}>
        <Switch>
          <Route path={`${path}/login`} component={Login} />
          <Route path={`${path}/new-login`} component={LoginNewUser} />
          {/* Authentication fails */}
          <Route path={`${path}/login-failed`} component={LoginFailed} />
          {/* Logged in via authentication provider, but user is not in the DAAS system */}
          <Route
            path={`${path}/access-failed`}
            render={() => (
              <LoginNoAccess
                title={t('LoginNoAccess.title')}
                contentBodyText={t('LoginNoAccess.content')}
                instructionBodyText={t('LoginNoAccess.instruction')}
                logoutButtonLabel={t('LoginNoAccess.logoutButton')}
              />
            )}
          />
          {/* Logged in via authentication provider, but user onboarding date is scheduled in future */}
          <Route
            path={`${path}/access-not-yet-available`}
            render={() => (
              <LoginNoAccess
                title={t('LoginAccessPrescheduledInFuture.title')}
                contentBodyText={t('LoginAccessPrescheduledInFuture.content')}
                instructionBodyText={t('LoginAccessPrescheduledInFuture.instruction')}
                logoutButtonLabel={t('LoginAccessPrescheduledInFuture.logoutButton')}
              />
            )}
          />
          {/* Logged in but backend gives 403 for certain resource */}
          <Route path={`${path}/access-denied`} component={NoAccessToResource} />
          <Route path={`${path}/logout`} component={LoggedOut} />
          <Route path={`${path}/authenticated`} component={Authenticated} />
          <Route path={`${path}/company-device-policy`} component={CompanyDevicePolicy} />
          {/* Maintenance mode is active */}
          <Route path={`${path}/maintenance-mode`} component={MaintenanceMode} />
          <Redirect to={`${path}/login`} />
        </Switch>
      </Div>
    </Div>
  );
};

export default Authentication;
